export default __webpack_public_path__ + "static/media/stackoverflow.e789aad8.png";